import { get, post } from "@/api";
import type { UniloginInstitution } from "@/types";

export function getInstitutions() {
  return get<UniloginInstitution[]>("/v1/me/unilogin/institutions");
}

export function setPrimaryInstitution(institutionId: string) {
  return post<void>("/v1/me/unilogin/institutions/primary", { institutionId });
}
